/* ============================================================
   Micromini — interactions
   ============================================================ */
(function () {
  "use strict";

  /* ---- Placeholder product tiles (gamepad glyph + label) ---- */
  var padSVG =
    '<svg class="pad-glyph" viewBox="0 0 48 32" fill="none" stroke="currentColor" stroke-width="1.6">' +
    '<rect x="1" y="6" width="46" height="24" rx="11"/>' +
    '<path d="M11 14v6M8 17h6"/>' +
    '<circle cx="33" cy="15" r="1.6"/><circle cx="38" cy="20" r="1.6"/>' +
    '<circle cx="38" cy="11" r="1.6"/><circle cx="28" cy="20" r="1.6"/>' +
    "</svg>";
  document.querySelectorAll(".media-tile[data-product]").forEach(function (tile) {
    var img = tile.getAttribute("data-img");
    if (img) {
      tile.classList.add("has-img");
      tile.innerHTML = '<img class="product-photo" src="' + img + '" alt="' + tile.getAttribute("data-product") + '" loading="lazy" />';
      return;
    }
    var label = tile.getAttribute("data-product");
    tile.innerHTML = padSVG + '<span class="ph">' + label + "<br>product shot</span>";
    tile.querySelector(".ph").style.position = "absolute";
    tile.querySelector(".ph").style.bottom = "12px";
    tile.querySelector(".ph").style.left = "0";
    tile.querySelector(".ph").style.right = "0";
  });

  /* ---- Mobile menu ---- */
  var burger = document.getElementById("hamburger");
  var menu = document.getElementById("mobileMenu");
  if (burger && menu) {
    burger.addEventListener("click", function () {
      var open = menu.classList.toggle("open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    menu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        menu.classList.remove("open");
        burger.setAttribute("aria-expanded", "false");
      });
    });
  }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll(".faq-item").forEach(function (item) {
    var q = item.querySelector(".faq-q");
    var a = item.querySelector(".faq-a");
    q.addEventListener("click", function () {
      var isOpen = item.classList.contains("open");
      // close all
      document.querySelectorAll(".faq-item.open").forEach(function (o) {
        o.classList.remove("open");
        o.querySelector(".faq-a").style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add("open");
        a.style.maxHeight = a.scrollHeight + "px";
      }
    });
  });

  /* ---- Scroll reveal ---- */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    document.querySelectorAll(".reveal").forEach(function (el, i) {
      // gentle stagger within the same row
      el.style.transitionDelay = (i % 4) * 70 + "ms";
      io.observe(el);
    });
  } else {
    document.querySelectorAll(".reveal").forEach(function (el) {
      el.classList.add("in");
    });
  }

  /* ---- Header shadow on scroll ---- */
  var header = document.querySelector(".mmx-header") || document.querySelector(".header");
  var onScroll = function () {
    if (!header) return;
    if (window.scrollY > 8) {
      header.style.boxShadow = "0 10px 30px -18px rgba(0,0,0,0.9)";
    } else {
      header.style.boxShadow = "none";
    }
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
})();


// === Header v2 — hamburger + scroll shadow ===
(function(){
  var header = document.getElementById('mmxHeader');
  var ham = document.getElementById('hamburger');
  var mobileNav = document.getElementById('mobileMenu');

  // Scroll shadow
  if(header) {
    window.addEventListener('scroll', function(){
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // Hamburger toggle (new mmx classes)
  if(ham && mobileNav) {
    ham.addEventListener('click', function(){
      var open = ham.classList.toggle('is-open');
      mobileNav.classList.toggle('is-open', open);
      ham.setAttribute('aria-expanded', String(open));
    });
    // Close on mobile link click
    mobileNav.querySelectorAll('.mmx-mobile-link').forEach(function(link){
      link.addEventListener('click', function(){
        ham.classList.remove('is-open');
        mobileNav.classList.remove('is-open');
        ham.setAttribute('aria-expanded', 'false');
      });
    });
  }
})();


// === Shop mega-menu (click toggle for touch + a11y) ===
(function(){
  var shop = document.querySelector('.mmx-shop');
  var trigger = shop && shop.querySelector('.mmx-shop-trigger');
  if(!shop || !trigger) return;
  document.addEventListener('click', function(e){
    if(!shop.contains(e.target)){ shop.classList.remove('is-open'); trigger.setAttribute('aria-expanded','false'); }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ shop.classList.remove('is-open'); } });
})();


// === Light/Dark theme toggle (delegated — robust to load order / re-renders) ===
document.addEventListener('click', function(e){
  var btn = e.target.closest ? e.target.closest('#mmxThemeToggle') : null;
  if(!btn) return;
  var cur = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
  var next = cur === 'dark' ? 'light' : 'dark';
  document.documentElement.setAttribute('data-theme', next);
  try { localStorage.setItem('mmx-theme', next); } catch(err){}
});
